const _T = str => str;

export const unsavedChangesWarning = _T('You have unsaved changes in your configuration. Would you like to save the changes before exiting?');
export const unsavedChangesDialogTitle = _T('Unsaved Changes');